import script from "./PromoMailListPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromoMailListPage.vue?vue&type=script&setup=true&lang=ts"

import "./PromoMailListPage.vue?vue&type=style&index=0&id=72a5328c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72a5328c"]])

export default __exports__